<template>
  <v-container id="contact-register-report" fluid tag="section">
    <FilterForm 
      :filterForm="filterForm"
      :contactSources="contactSources"
      :productGroups="productGroups"
      @getHeightTable="getHeightTable"
    />

    <v-card class="mt-4 mb-2">
      <v-tabs
        v-model="tab"
        grow
        @change="onChangeTab()"
      >
      <v-tabs-slider></v-tabs-slider>

          <v-tab
            v-for="(item, key) in tabs"
            :key="key"
          >
            {{item}}
          </v-tab>
          <v-tab-item>
            <ContactRegisterReportTable
              :dataReport="dataReport"
              :total="total"
            />
          </v-tab-item>
          <v-tab-item>
            <ContactRegisterReportTable
              :dataReport="dataReport"
              :total="total"
            />
          </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import TokenService from '@/helpers/token';
import * as moment from 'moment'
import { formatDate } from '@/helpers/utils'
import FilterForm from './components/FilterForm'
import ContactRegisterReportTable from './components/ContactRegisterReportTable'

import RepositoryFactory from "@/repositories/RepositoryFactory";
import { moduleSchoolLevel } from "../../../helpers/constants";
const ReportRepository = RepositoryFactory.get('report');
const ContactSourceRepository =  RepositoryFactory.get('contact_source');
const ProductGroupRepository =  RepositoryFactory.get('product_group');

export default {
  components: { FilterForm, ContactRegisterReportTable },
  data () {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        contactSourcesId: '',
        productGroupsId: '',
        schoolLevelIds: [1]
      },
      dataReport: [],
      contactSources: [],
      productGroups: [],
      total: 0,
      tabs: ['Tiểu học', 'THPT', 'THCS'],
      tab: 0
    }
  },

  created () {
    this.getContactSource()
    this.getProductGroup()
    Bus.$on('contact-register-report-filter', (filterForm) => {
      this.filterForm = filterForm
      this.fetchData()
    })
  },
  updated() {
    setTimeout(() => {
      this.getHeightTable()
    }, 300)
  },
  beforeDestroy() {
    Bus.$off('contact-register-report-filter');
  },
  methods: {
    async fetchData () {
      const loader = this.$loading.show()

      let startDate = moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD')
      let endDate = moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD')
      const params = {
        importUpdatedAt: [startDate, endDate],
        sourceId: this.filterForm.contactSourcesId,
        productGroupId: this.filterForm.productGroupsId,
        schoolLevelIds: this.filterForm.schoolLevelIds
      }

      const response = await ReportRepository.registerReport(params)

      loader.hide()

      if (response.success) {
        this.dataReport = _.get(response.data, 'dataSources')
        this.total = _.get(response.data, 'total')
      }
    },

    async getContactSource () {
      const res = await ContactSourceRepository.list({limit: 1000})
      if (res.success) {
        this.contactSources = _.get(res, 'data', '')
      }
    },

    async getProductGroup () {
      const res = await ProductGroupRepository.list()
      if (res.success) {
        this.productGroups = _.get(res, 'data', '')
      }
    },
    getHeightTable() {
      let heightTable = document.getElementsByClassName('contact-register-table-container')
      let heightFilter = document.querySelector('.report-register-filter').clientHeight
      let totalHeader = heightFilter + 134 + 'px'
      heightTable.forEach(item => {
        item.style.height = `calc(100vh - ${totalHeader})`
      })
    },
    onChangeTab() {
      if (this.tab < 2) {
        this.filterForm.schoolLevelIds = [this.tab + 1]
      } else {
        switch (this.tab) {
          case 2:
            this.filterForm.schoolLevelIds = [moduleSchoolLevel.THCS];
            break;
        }
      }
      this.fetchData()
    },
  },
}
</script>
<style lang="scss" scoped>
#contact-register-report {
  padding: 0px 15px;
}
</style>
